import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, switchMap, catchError, throwError, tap, finalize } from "rxjs";
import { PaymentDataService } from "src/app/libs/services/payment-data/payment-data.service";
import { IdempotencyService } from "../service/idempotency.service";

@Injectable()
export class ChargeInterceptor implements HttpInterceptor {

  constructor(
    private paymentDateService: PaymentDataService,
    private idempotencyService: IdempotencyService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Só intercepta endpoints de cobrança (ajuste conforme sua API)
    if (!req.url.includes('/charger')) {
      return next.handle(req);
    }

    const body = req.body;

    // Se não tem cartão, segue fluxo normal
    if (!body?.cardNumber || body.cardNumber.length <= 0) {
      return this.injectIdempotencyKey(req, next, body);
    }

    const [month, year] = body.cardExpirationDate?.split('/') || ['', ''];

    const payload = {
      type: 'card',
      card: {
        number: body.cardNumber,
        holder_name: body.cardHolderName,
        exp_month: month,
        exp_year: year,
        cvv: body.cardCvv
      }
    };

    return this.paymentDateService.createCardToken(payload).pipe(
      switchMap(res => {
        let newBody = { ...body };

        if (res?.id) {
          // Remove dados sensíveis
          delete newBody.cardNumber;
          delete newBody.cardHolderName;
          delete newBody.cardCvv;
          delete newBody.cardExpirationDate;

          newBody.cardToken = res.id;
          newBody.lastFourDigits = res.card.last_four_digits;
          newBody.brand = res.card.brand;
        }

        return this.injectIdempotencyKey(req, next, newBody);
      }),
      catchError(err => {
        console.error('Erro ao tokenizar cartão:', err);
        return throwError(() => err);
      })
    );
  }

  private injectIdempotencyKey(req: HttpRequest<any>, next: HttpHandler, body: any): Observable<HttpEvent<any>> {
    const key = this.idempotencyService.acquireKey();

    const cloned = req.clone({
      body,
      setHeaders: {
        'Idempotency-Key': key
      }
    });

  return next.handle(cloned).pipe(
    finalize(() => {
      this.idempotencyService.completeRequest();
    })
  );
  }
}